import React from 'react'
import { PixelDiv } from 'pixel-base'
import DCLogo from 'utils/icons/dcIcon'

import StoreDaraz from 'utils/icons/store-daraz'
import StoreIcon from 'utils/icons/store-icon'
import StoreShopify from 'utils/icons/store-shopify'
import StoreWoocom from 'utils/icons/store-woocom'

const StoreLogos = ({ store_type }) => {
  let icon = <StoreIcon />
  switch (store_type) {
    case 'woocom':
      icon = <StoreWoocom />
      break
    case 'daraz':
      icon = <StoreDaraz />
      break
    case 'ems':
      icon = <DCLogo />
      break
    case 'shopify':
      icon = <StoreShopify />
      break
  }

  return icon
}
export default StoreLogos
